var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _c(
      "ul",
      { staticClass: "orgstruck-list" },
      [
        _vm._l(_vm.parentComs, function(parentCom) {
          return _c("li", { staticClass: "orgstruck-item" }, [
            _c(
              "div",
              {
                staticClass: "com-first",
                on: {
                  click: function($event) {
                    _vm.switchComBlock(parentCom.id)
                  }
                }
              },
              [
                _c("i", { staticClass: "icon iconfont icon-com font-gray3" }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(parentCom.name))]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "icon iconfont arrow",
                  class: {
                    "icon-down": !parentCom.expanded,
                    "icon-up": parentCom.expanded
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "post-third",
                class: {
                  "display-none": !parentCom.expanded,
                  "display-block": parentCom.expanded
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "post-item" },
                  _vm._l(parentCom.comRoleList, function(comPost) {
                    return _c(
                      "div",
                      {
                        staticClass: "name",
                        class: { active: _vm.isSelected(comPost.id) },
                        on: {
                          click: function($event) {
                            _vm.asSelected(comPost)
                          }
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "icon iconfont icon-post font-gray3"
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            attrs: {
                              title: comPost.comName + " - " + comPost.name
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(comPost.comName) +
                                " - " +
                                _vm._s(comPost.name)
                            )
                          ]
                        )
                      ]
                    )
                  })
                )
              ]
            )
          ])
        }),
        _vm._v(" "),
        _vm.assignCom.id != null
          ? _c("li", { staticClass: "orgstruck-item" }, [
              _c(
                "div",
                {
                  staticClass: "com-first",
                  on: {
                    click: function($event) {
                      _vm.switchComBlock(_vm.assignCom.id)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "icon iconfont icon-com font-gray3" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.assignCom.name) + " ")]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "icon iconfont arrow",
                    class: {
                      "icon-down": !_vm.assignCom.expanded,
                      "icon-up": _vm.assignCom.expanded
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "post-third",
                  class: {
                    "display-none": !_vm.assignCom.expanded,
                    "display-block": _vm.assignCom.expanded
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "post-item" },
                    _vm._l(_vm.assignCom.comRoleList, function(comPost) {
                      return _c(
                        "div",
                        {
                          staticClass: "name",
                          class: { active: _vm.isSelected(comPost.id) },
                          on: {
                            click: function($event) {
                              _vm.asSelected(comPost)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "icon iconfont icon-post font-gray3"
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              attrs: {
                                title: comPost.comName + " - " + comPost.name
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(comPost.comName) +
                                  " - " +
                                  _vm._s(comPost.name)
                              )
                            ]
                          )
                        ]
                      )
                    })
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "orgstruck-item" }, [
          _c(
            "div",
            {
              staticClass: "com-first",
              on: {
                click: function($event) {
                  _vm.switchComBlock(_vm.ctxCom.id)
                }
              }
            },
            [
              _c("i", { staticClass: "icon iconfont icon-com font-gray3" }),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.ctxCom.bizUnitName) + " （本公司）")
              ]),
              _vm._v(" "),
              _c("i", {
                staticClass: "icon iconfont arrow",
                class: {
                  "icon-down": !_vm.ctxCom.expanded,
                  "icon-up": _vm.ctxCom.expanded
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "post-third",
              class: {
                "display-none": !_vm.ctxCom.expanded,
                "display-block": _vm.ctxCom.expanded
              }
            },
            [
              _c(
                "div",
                { staticClass: "post-item" },
                _vm._l(_vm.ctxCom.comRoleList, function(comPost) {
                  return _c(
                    "div",
                    {
                      staticClass: "name",
                      class: { active: _vm.isSelected(comPost.id) },
                      on: {
                        click: function($event) {
                          _vm.asSelected(comPost)
                        }
                      }
                    },
                    [
                      _c("i", {
                        staticClass: "icon iconfont icon-post font-gray3"
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          attrs: {
                            title: comPost.comName + " - " + comPost.name
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(comPost.comName) +
                              " - " +
                              _vm._s(comPost.name)
                          )
                        ]
                      )
                    ]
                  )
                })
              )
            ]
          )
        ]),
        _vm._v(" "),
        _vm.assignCom2.id != null
          ? _c("li", { staticClass: "orgstruck-item" }, [
              _c(
                "div",
                {
                  staticClass: "com-first",
                  on: {
                    click: function($event) {
                      _vm.switchComBlock(_vm.assignCom2.id)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "icon iconfont icon-com font-gray3" }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.assignCom2.name))]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "icon iconfont arrow",
                    class: {
                      "icon-down": !_vm.assignCom2.expanded,
                      "icon-up": _vm.assignCom2.expanded
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "post-third",
                  class: {
                    "display-none": !_vm.assignCom2.expanded,
                    "display-block": _vm.assignCom2.expanded
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "post-item" },
                    _vm._l(_vm.assignCom2.comRoleList, function(comPost) {
                      return _c(
                        "div",
                        {
                          staticClass: "name",
                          class: { active: _vm.isSelected(comPost.id) },
                          on: {
                            click: function($event) {
                              _vm.asSelected(comPost)
                            }
                          }
                        },
                        [
                          _c("i", {
                            staticClass: "icon iconfont icon-post font-gray3"
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              attrs: {
                                title: comPost.comName + " - " + comPost.name
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(comPost.comName) +
                                  " - " +
                                  _vm._s(comPost.name)
                              )
                            ]
                          )
                        ]
                      )
                    })
                  )
                ]
              )
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group top" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "form-value width-3x " }, [
        _vm.postStaffList.length > 0
          ? _c("ul", { staticClass: "orgstruck-list" }, [
              _c("li", { staticClass: "orgstruck-item" }, [
                _c("div", { staticClass: "post-third" }, [
                  _c(
                    "div",
                    { staticClass: "post-item" },
                    _vm._l(_vm.postStaffList, function(postStaff) {
                      return _c(
                        "div",
                        {
                          staticClass: "name",
                          class: {
                            active: _vm.isSelectedPostStaff(postStaff.id)
                          },
                          on: {
                            click: function($event) {
                              _vm.postStaffSelected(postStaff)
                            }
                          }
                        },
                        [_c("span", [_vm._v(_vm._s(postStaff.name))])]
                      )
                    })
                  )
                ])
              ])
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("选择审核人")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-394079a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394079a1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/merchant/ComActionPostSelect.vue
// module id = 2100
// module chunks = 0